module.exports = __webpack_public_path__ + "img/slot.691b4361.png";